export default __webpack_public_path__ + "static/media/case5.2254a461.webp";